module.exports = __webpack_public_path__ + "img/touxiang.35621e19.png";